export default __webpack_public_path__ + "images/OH.07a54bc.png";